import styled from 'styled-components';

import { HorizontalCenterBlock, VerticalHorizontalCenterBlock } from '../../../styled';

export const CustomizationFrameWrapper = styled.div`
  border-radius: 4px;
  width: 100%;
  border: 1px solid ${(props) => props.theme.colors.stroke};
`;

export const WidgetFrame = styled(VerticalHorizontalCenterBlock)`
  border-radius: inherit;
  height: 650px;
  background: ${(props) => props.theme.colors.tableCell};
`;

export const BlockWrapper = styled.div`
  margin-bottom: 24px;
`;

export const UploadWrapper = styled(HorizontalCenterBlock)`
  margin-bottom: 24px;
`;
